
<div class="d-flex items-center" *ngIf="currentUser != null && currentUser != CurrentUserIsNotLoggedIn">
    <div class="d-inline-flex align-items-center me-3">
        <span class="me-2">Hello,</span>
        <div ngbDropdown class="d-inline-block">
            <button class="btn btn-outline-dark" ngbDropdownToggle>{{ currentUser.EmployeeInfo.FirstName }}</button>
            <div ngbDropdownMenu>
                <span ngbDropdownItem>Current User: {{ currentUser.Username }}</span>
                <button ngbDropdownItem (click)="GetLocation()">Get Location <span *ngIf="LastPosition">{{LastPosition.coords.latitude}}, {{LastPosition.coords.longitude}}</span></button>
                <button ngbDropdownItem (click)="Logout()">Logout</button>
            </div>
        </div>
    </div>
    <i *ngIf="messages.length > 0" class="notification-icon fa-regular fa-bell" [ngbPopover]="notificationsContent" [popoverTitle]="notificationsTitle" popoverClass="no-max-width">
        <span class="notification-count">{{ messages.length }}</span>
    </i>
    <i *ngIf="messages.length == 0" class="notification-icon empty fa-solid fa-bell-slash">
        
    </i>
    <ng-template #notificationsTitle>Notifications</ng-template>
    <ng-template #notificationsContent>
        <div class="notification-list">
            <div class="notification-item py-2" *ngFor="let message of messages; last as last" (click)="MessageClicked(message.MessageID)">
                <div class="d-flex justify-content-between fw-bold fs-6 mb-2">
                    <span>[ID: {{ message.MessageID }}] {{ message.CallerName }}</span>
                    <span>{{ message.CallerPhoneNumber }}</span>
                </div>
                <div>
                    {{ message.MessageText }}
                </div>
                <hr *ngIf="!last" />
            </div>
        </div>
    </ng-template>
</div>
<span *ngIf="currentUser == CurrentUserIsNotLoggedIn"><a class="nav-link text-dark" [routerLink]="['/login']">Login</a></span>
